// extracted by mini-css-extract-plugin
module.exports = {"pd10":"index_pd10_hKxqJ","minHeight":"index_minHeight_47i97","anchor":"index_anchor_3wTUO","cancel":"index_cancel_2OSoc","padding":"index_padding_2-KSY"};